import {ApiRequest} from './request'

export default function support(app)
{

    /**
     * Mark ticket as read
     *
     * @param event
     */

    const markAsRead = async function(event) {

        // Prevent the default action
        event.preventDefault()
        event.stopPropagation()

        // Make the ticket as read
        await ApiRequest($(this).data('action'), null, 'POST')

        // Remove the unread class
        $(this).parents('.item').removeClass('unread')

    }

    /**
     * Take the user to the ticket page
     *
     * @param event
     */

    const viewTicket = function(event) {

        if($(event.target).hasClass('mark-read')) return

        window.location.href = $(this).data('href')

    }

    /**
     * Expand the search on focus
     */

    const onSearchFocus = function()
    {
        $(this).parents('.form-field').removeClass('collapsed')
    }

    /**
     * Collapse the search input on blur
     */

    const onSearchBlur = function()
    {
        if($(this).val().length > 0) return
        $(this).parents('.form-field').addClass('collapsed')
    }

    $(function(){

        // Get the body
        const $body = $('body')

        $body.on('click', '.widget.messages [data-href]', viewTicket)
        $body.on('click', '.widget.messages .item .mark-read', markAsRead)
        $body.on('focus', '.form-field.expandable :input', onSearchFocus)
        $body.on('blur', '.form-field.expandable :input', onSearchBlur)

    })

}
